/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.roles.RoleScopeType
*/
export var RoleScopeType;
(function (RoleScopeType) {
    RoleScopeType["TENANT"] = "TENANT";
    RoleScopeType["PROJECT"] = "PROJECT";
})(RoleScopeType || (RoleScopeType = {}));
//# sourceMappingURL=RoleScopeType.js.map